import React, {useState, useEffect, useRef} from 'react';

import './style.scss';

const JumpLinks = () => {
    const anchors = document.querySelectorAll('.api-documentation .section > a');
    const [activeLink, setActiveLink] = useState(false);
    const {
        ref,
        isComponentVisible,
        setIsComponentVisible
    } = useComponentVisible(false);

    let jumpLinks = [];

    for (let i = 0; i < anchors.length; i++) {
        let anchor_link = anchors[i].getAttribute('href');
        jumpLinks.push({
            url: anchor_link,
            text: anchors[i].textContent,
            active: activeLink === anchor_link,
        });
    }

    const toggleJumpNav = () => {
        setIsComponentVisible(!isComponentVisible);
    };

    const clickLink = (e) => {
        e.stopPropagation();
    };

    useEffect(() => {

        const jumpLinksScroll = () => {

            let distance = 0;
            let active = -1;

            for (let i = 0; i < anchors.length; i++) {
                let top = anchors[i].offsetTop;
                let scroll = window.pageYOffset;

                if (scroll >= top - window.innerHeight / 2) {
                    if (active < 0 || distance > Math.abs(scroll - top)) {
                        active = i;
                        distance = scroll - top;
                    }
                }
            }

            let active_link = active >= 0 ? anchors[active].getAttribute('href') : false;
            setActiveLink(active_link);
        };

        window.addEventListener("scroll", jumpLinksScroll, {passive: true});

        return () => window.removeEventListener("scroll", jumpLinksScroll);
    }, [anchors, activeLink]);

    return (
            <div className={`jump-links open-${isComponentVisible} count-${jumpLinks.length}`}
                 ref={ref}>
                <a
                    data-test-id="jump-links-toggle-link"
                    data-external-target="jump-links-toggle-link" 
                    className="jump-links-toggle"
                    onClick={toggleJumpNav}
                >
                    <h4>Jump To</h4>
                </a>
                <div className={`jump-links-links`}>
                    {jumpLinks.map(({url, text, active}, i) => {
                        return <a 
                                    data-test-id={`jump-link-${text}`}
                                    data-external-target={`jump-link-${text}`}
                                    key={i}
                                    className={`jump-link active-${active}`}
                                    href={url} onClick={clickLink}
                                >
                                    {text}
                                </a>;
                    })}
                </div>
            </div>
    );
};

export default JumpLinks;

function useComponentVisible(initialIsVisible) {
    const [isComponentVisible, setIsComponentVisible] = useState(initialIsVisible);
    const ref = useRef(null);

    const handleClickOutside = event => {
        if (ref.current && !ref.current.contains(event.target)) {
            setIsComponentVisible(false);
        }
    };

    useEffect(() => {
        document.addEventListener("click", handleClickOutside, true);
        return () => {
            document.removeEventListener("click", handleClickOutside, true);
        };
    });

    return {ref, isComponentVisible, setIsComponentVisible};
}